<div class="spaceing-area"></div>

<footer class="footer">
  <div class="note">※實際資料以教務學務系統為準。</div>
  <div class="footer__Wrapper">
    <div class="footer__inner">

      <picture class="footer__inner--photo">
        <source>
        <source>
        <img class="schoolLogo" src="./images/img/LOGO-Footer.png" alt="">
      </picture>


      <p class="footer__inner--notice">若您對系統有疑問或建議，請寄信至
        <i class="far fa-envelope"></i><a href="mailto:paced_group@tmu.edu.tw" target="_blank">諮詢信箱</a>
        <i class="far fa-check-circle"></i><a href="https://forms.gle/HHkqJ5yVdXgeKzoZ9" target="_blank">學生滿意度調查表單</a>
      </p>
      <p class="footer__inner--copyright">
        Copyright © 2022 臺北醫學大學 Taipei Medical University
      </p>

    </div>
  </div>


  <!-- to top -->
</footer>
